import { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const PhoneLogin = ({ onSwitchToEmail }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSendOtp = (e) => {
    e?.preventDefault();
    setError('');

    if (!phoneNumber?.trim()) {
      setError('Phone number is required');
      return;
    }

    if (!/^[6-9]\d{9}$/?.test(phoneNumber)) {
      setError('Please enter a valid 10-digit Indian mobile number');
      return;
    }

    setIsLoading(true);
    setTimeout(() => {
      setOtpSent(true);
      setIsLoading(false);
    }, 1500);
  };

  const handleVerifyOtp = (e) => {
    e?.preventDefault();
    setError('');

    if (!otp?.trim()) {
      setError('OTP is required');
      return;
    }

    if (otp?.length !== 6) {
      setError('Please enter a valid 6-digit OTP');
      return;
    }

    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      alert('Phone login is not implemented in this demo');
    }, 1500);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-foreground">Login with Phone</h3>
        <button
          type="button"
          onClick={onSwitchToEmail}
          className="text-sm font-medium text-primary hover:text-primary/80 transition-smooth"
        >
          Use Email Instead
        </button>
      </div>
      {error && (
        <div className="flex items-start gap-3 p-4 bg-error/10 border border-error/20 rounded-lg">
          <Icon name="AlertCircle" size={20} color="var(--color-error)" className="flex-shrink-0 mt-0.5" />
          <p className="text-sm text-error">{error}</p>
        </div>
      )}
      {!otpSent ? (
        <form onSubmit={handleSendOtp} className="space-y-4">
          <Input
            type="tel"
            label="Mobile Number"
            placeholder="Enter 10-digit mobile number"
            value={phoneNumber}
            onChange={(e) => {
              setPhoneNumber(e?.target?.value);
              setError('');
            }}
            maxLength={10}
            required
            disabled={isLoading}
          />
          <Button
            type="submit"
            variant="default"
            size="lg"
            fullWidth
            loading={isLoading}
            iconName="Send"
            iconPosition="right"
          >
            Send OTP
          </Button>
        </form>
      ) : (
        <form onSubmit={handleVerifyOtp} className="space-y-4">
          <div className="p-4 bg-muted rounded-lg">
            <p className="text-sm text-muted-foreground">
              OTP sent to +91 {phoneNumber}
            </p>
          </div>
          <Input
            type="text"
            label="Enter OTP"
            placeholder="Enter 6-digit OTP"
            value={otp}
            onChange={(e) => {
              setOtp(e?.target?.value);
              setError('');
            }}
            maxLength={6}
            required
            disabled={isLoading}
          />
          <div className="flex gap-3">
            <Button
              type="button"
              variant="outline"
              size="lg"
              fullWidth
              onClick={() => {
                setOtpSent(false);
                setOtp('');
                setError('');
              }}
              disabled={isLoading}
            >
              Change Number
            </Button>
            <Button
              type="submit"
              variant="default"
              size="lg"
              fullWidth
              loading={isLoading}
              iconName="Check"
              iconPosition="right"
            >
              Verify OTP
            </Button>
          </div>
        </form>
      )}
    </div>
  );
};

export default PhoneLogin;